import request from "@/utils/request";
const api = {
  login: "/Login/Login",
  calogin: "/Login/CALogin",
};
export function login(param) {
  return request({
    url: api.login,
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    params: param,
  });
}
export function CAlogin(param) {
  return request({
    url: api.calogin,
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    params: param,
  });
}
